import React from "react";
import { Routes, Route } from "react-router-dom";
import RentalsLayout from "../RentalsLayout";
import AssetsList from "../../../pages/rentals/AssetsList";
import AssetCreate from "../../../pages/rentals/AssetCreate";
import AssetEdit from "../../../pages/rentals/AssetEdit";
import AssetDetail from "../../../pages/rentals/AssetDetail";
import ReservationsList from "../../../pages/rentals/ReservationsList";
import ReservationFlow from "../../../pages/rentals/ReservationFlow";
import ReservationDetail from "../../../pages/rentals/ReservationDetail";
import Trips from "../pages/Trips";

export default function RentalsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RentalsLayout />}>
        <Route index element={<AssetsList />} />
        <Route path="assets" element={<AssetsList />} />
        <Route path="asset/:id" element={<AssetDetail />} />
        <Route path="assets/new" element={<AssetCreate />} />
        <Route path="assets/:id/edit" element={<AssetEdit />} />
        <Route path="reservations" element={<ReservationsList />} />
        <Route path="reservations/new" element={<ReservationFlow />} />
        <Route path="reservations/:id" element={<ReservationDetail />} />
        <Route path="bookings" element={<Trips />} />
      </Route>
    </Routes>
  );
}
